import { Component, OnInit, forwardRef, Output, EventEmitter } from '@angular/core';
import { FormBuilder, ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import * as moment from 'moment-timezone';
import { locale } from 'devextreme/localization';
import 'devextreme-intl';
import { DateService } from '../../../services/date.service';

const DEFAULT_NULL_DATE = '0001-01-01T00:00:00Z';
@Component({
  selector: 'app-date',
  templateUrl: './date.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DateComponent),
      multi: true
    }
  ]
})
export class DateComponent implements OnInit, ControlValueAccessor {
  date: Date;
  onTouched: Function;
  onChange: Function;
  @Output() onChangeDateEmit = new EventEmitter<boolean>();
  @Output() onFocusOut = new EventEmitter<boolean>();

  constructor(protected formBuilder: FormBuilder,
    protected dateService: DateService) { }

  ngOnInit(): void {
    locale('pt-BR');
  }

  writeValue(value: any) {
    if (value && value !== DEFAULT_NULL_DATE) {
      this.date = moment(value).locale('pt-br').toDate();
    }
  }

  registerOnTouched(fn: any) {
    this.onTouched = fn;
  }

  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  onManualChangeDate(e: any) {
    const date = moment(e.value, 'DD/MM/YYYY').utc();

    if (!this.dateService.isValid(date)) {
      setTimeout(() => this.onChange(null));
      this.onChangeDateEmit.emit(true);
    } else {
      setTimeout(() => this.onChange(date));
      this.onChangeDateEmit.emit(true);
    }
    setTimeout(() => { this.onFocusOut.emit(true); });
  }

  onChangeDate(e: any) {
    setTimeout(() => this.onChange(moment(e.value, 'DD/MM/YYYY').utc()));
    this.onChangeDateEmit.emit(true);
  }
}
